import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Alert } from 'react-bootstrap';
import { orderBy } from 'lodash';
import courts from '../../../data/courts';
import appellateNosOptions from '../../../data/appellateNosOptions';
import { searchAppellate, resetLocalCourtSearch } from '../../../redux/actions/localCourtSearchAction';
import { validateAppellate } from './formValidation';
import CaseNumberTooltip from '../FormElements/tooltips/caseNumberTooltip/CaseNumberTooltip';
import { hasValidClientCode } from '../../../redux/actions/clientCodeAction';

import './LocalCourtSearch.less';

const regionOptions = orderBy(courts.reduce((accum, next) => {
  if (next.type === 'appellate') {
    accum.push({
      label: next.name,
      value: next.code,
    });
  }
  return accum;
}, []), ['label'], ['asc']);

const onSubmit = (values, { clientCode, onSearch, isValidClientCode }) => {
  if (!isValidClientCode()) {
    return;
  }

  values.pacer_client = clientCode;
  onSearch(values);
};

export const AppellateForm = props => (
  <Form
    onSubmit={values => onSubmit(values, props)}
    initialValues={{}}
    validate={validateAppellate}
    render={({ handleSubmit, submitFailed, form, errors, error }) => (
      <form onSubmit={handleSubmit} className="local-court-form">
        <div className="form-item">
          <label>Region</label>
          <Field
            name="court_code"
            parse={({ value }) => value}
          >
            {({ input, meta }) => (
              <Select
                {...input}
                clearable={false}
                options={regionOptions}
                placeholder="Select a jurisdiction"
                className={`form-select ${meta.error && meta.submitFailed ? 'error' : ''}`}
              />
            )}
          </Field>
        </div>
        <div className="form-item">
          <label>
            Case Number
            <CaseNumberTooltip />
          </label>
          <Field
            name="case_no"
            component="input"
            type="text"
            maxLength="128"
            className={`form-input ${submitFailed && errors && errors.case_no ? 'error' : ''}`}
          />
        </div>
        <div className="form-item form-item-group party-attorney">
          <div>
            <label>Party / Attorney</label>
            <Field
              name="party_name"
              component="input"
              type="text"
              maxLength="128"
              className={`form-input ${submitFailed && errors && errors.party_name ? 'error' : ''}`}
            />
          </div>
          <div>
            <label>
              <Field
                name="search_party"
                component="input"
                type="checkbox"
              />
              Party
            </label>
          </div>
          <div>
            <label>
              <Field
                name="search_attorney"
                component="input"
                type="checkbox"
              />
              Attorney
            </label>
          </div>
        </div>
        <div className="form-item">
          <label>Nature of Suit</label>
          <Field name="nos">
            {({ input }) => (
              <Select
                {...input}
                multi
                options={appellateNosOptions}
                className="form-select"
              />
            )}
          </Field>
        </div>
        <div className="form-item form-item-group">
          <div>
            <label>Filed Date from</label>
            <Field name="filed_from">
              {({ input, meta }) => (
                <DatePicker
                  {...input}
                  selected={input.value ? moment(input.value) : null}
                  onChangeRaw={input.onChange}
                  dateFormat="MM/DD/YYYY"
                  className={`form-input ${meta.submitFailed && meta.error ? 'error' : ''}`}
                />
              )}
            </Field>
          </div>
          <div>
            <label>Filed Date to</label>
            <Field name="filed_to">
              {({ input, meta }) => (
                <DatePicker
                  {...input}
                  selected={input.value ? moment(input.value) : null}
                  onChangeRaw={input.onChange}
                  dateFormat="MM/DD/YYYY"
                  className={`form-input ${meta.submitFailed && meta.error ? 'error' : ''}`}
                />
              )}
            </Field>
          </div>
        </div>
        <div className="form-item form-item-group">
          <div>
            <label>Closed Date from</label>
            <Field name="closed_from">
              {({ input, meta }) => (
                <DatePicker
                  {...input}
                  selected={input.value ? moment(input.value) : null}
                  onChangeRaw={input.onChange}
                  dateFormat="MM/DD/YYYY"
                  className={`form-input ${meta.submitFailed && meta.error ? 'error' : ''}`}
                />
              )}
            </Field>
          </div>
          <div>
            <label>Closed Date to</label>
            <Field name="closed_to">
              {({ input, meta }) => (
                <DatePicker
                  {...input}
                  selected={input.value ? moment(input.value) : null}
                  onChangeRaw={input.onChange}
                  dateFormat="MM/DD/YYYY"
                  className={`form-input ${meta.submitFailed && meta.error ? 'error' : ''}`}
                />
              )}
            </Field>
          </div>
        </div>

        <div className="warning">
          WARNING: By pressing on the "Search" button you will be billed for the total number of pages.
          This search is not subject to the 30-page limit on PACER charges so DO NOT use broad search criteria.
        </div>

        <div className="action-btn-container">
          <button type="submit" className="form-submit green action-btn-search">
            Search
          </button>
          <button
            type="button"
            className="form-submit"
            onClick={() => { form.reset(); props.onClickSearchReset(); }}
          >
            Clear
          </button>
        </div>
        {submitFailed && error &&
          <Alert bsStyle="danger">
            <div>{error}</div>
          </Alert>
        }
      </form>
    )}
  />
);

AppellateForm.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onClickSearchReset: PropTypes.func.isRequired,
  clientCode: PropTypes.string,
};

AppellateForm.defaultProps = {
  clientCode: '',
};

const mapStateToProps = state => ({
  clientCode: state.getIn(['clientCodeReducer', 'sessionClientCode']),
});

const mapDispatchToProps = {
  onSearch: searchAppellate,
  onClickSearchReset: resetLocalCourtSearch,
  isValidClientCode: hasValidClientCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppellateForm);



// WEBPACK FOOTER //
// ./src/components/search/localCourtSearch/AppellateForm.jsx